export default __webpack_public_path__ + "static/photo-header-e7f3d69b23ccd578319f5a39c6d3baf8.jpg";